import { HomePageData } from "../../domain/models/HomePageData";
import type { HomePageDataDTO } from "../dto/homePageData.dto";

/**
 * Adapter converts DTO -> Domain model
 * Applies domain logic (defaults, transformations)
 * Works with both DTO (from API) and plain object (from Redux)
 */
export function adaptHomePageDataDtoToDomain(
  input: HomePageDataDTO | Record<string, unknown>
): HomePageData {
  return new HomePageData(input as Record<string, unknown>);
}

/**
 * Convert domain model (class instance) to plain object for Redux serialization
 */
export function homePageDataToPlainObject(data: HomePageData): Record<string, unknown> {
  return data.data;
}

